import { Module } from "vuex";
import ProductsService from "@/services/products.service";

export interface ProductState {
  isLoading: boolean;
}

const productsService = new ProductsService();

const productModule: Module<ProductState, any> = {
  namespaced: true,
  state: () => ({
    isLoading: false,
  }),
  getters: {},
  mutations: {
    SET_LOADING(state, value: boolean) {
      state.isLoading = value;
    },
  },
  actions: {
    addProduct({ commit }, productId: number) {
      commit("SET_LOADING", true);
      return productsService.addProduct(productId).finally(() => {
        commit("SET_LOADING", false);
      });
    },
    disableAddon({ dispatch }, productId: number) {
      return productsService
        .removeProduct(productId)
        .then((res) => {
          if (!res.data.response) return false;
          return dispatch("tariff/updateSubscriptionDetails", null, {
            root: true,
          }).then(() => true);
        })
        .catch(() => false);
    },
  },
};

export default productModule;
